/* eslint-disable */

import * as clientService from "./httpsClient";

export const getDestinationPackage = async (accessToken, params) => {
  try {
    const domain = `destinationpackage`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createDestinationPackageService = async (accessToken, body) => {
  try {
    const domain = `destinationpackage/service`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getDestinationPackageById = async (accessToken, id, params) => {
  try {
    const domain = `destinationpackage/${id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const updateDestinationPackage = async (accessToken, body) => {
  try {
    const domain = `destinationpackage`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteDestinationPackage = async (accessToken, body) => {
  try {
    const domain = `destinationpackage`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const exportExcel = async (accessToken, params) => {
  try {
    const domain = `destinationpackage/export-excel`;
    return await clientService.exportExcel(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const deleteMultiDestinationPackage = async (accessToken, params) => {
  try {
    const domain = `destinationpackage/delete-all`;
    return await clientService.postApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getDestinationPackageContainer = async (accessToken, params) => {
  try {
    const domain = `destinationpackage/list-destination-package`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};
